import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  border: none;
  padding: 10px 0px 0px 0px;
`;
